<xplora-website-header></xplora-website-header>
<main class="main_content">
  <router-outlet />
</main>
<xplora-website-footer></xplora-website-footer>